import { render, staticRenderFns } from "./ReportMonthlyBookings.vue?vue&type=template&id=a664af96"
import script from "./ReportMonthlyBookings.vue?vue&type=script&lang=js"
export * from "./ReportMonthlyBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports